"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fin-deposit-rule.dto.js.map